import React, { FC } from 'react';

import styles from './HighlightWord.scss';

type HighlightWord = {
  children?: string;
  words?: string[];
};

const escapeRegExp = (arr: string[] = []) => (
  arr.map((str) => `(${str?.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1')})`)
);

export const HighlightWord: FC<HighlightWord> = ({ children = '', words = [] }) => {
  const reg = new RegExp(escapeRegExp(words).join('|'), 'i');
  const parts = String(children).split(reg);

  if (words?.length) {
    return parts.map((part, index) => (
      // eslint-disable-next-line react/no-array-index-key
      (reg.test(part) ? <mark key={index} className={styles.highlight}>{part}</mark> : part)
    ));
  }
  return children;
};
